export default __webpack_public_path__ + "images/builders.d0035672bdb4f895be7433b329dda4f9.svg";